import {
  Box,
  Button,
  Flex,
  Image,
  Spinner,
  InputGroup,
  Textarea,
  Text,
  Select,
  Avatar,
  useDisclosure,
  Grid,
  GridItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import {
  AddIcon,
  EditIcon,
  DeleteIcon,
  CheckIcon,
  CloseIcon,
} from "@chakra-ui/icons";
import { Tooltip } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as yup from "yup";
import { constant } from "common/constant";
import { getApi, postApi, putApi } from "common/services/api";
import { generateValidationSchema } from "services/Crm/utils";
import { vaultFormChange } from "services/Vault/utils/formChangeUtils";
import { crmConstant } from "services/Crm/constant";
import DeleteIconCustom from "common/assets/img/delete-icon.png";
import WhiteEditIcon from "common/assets/img/whiteEditIcon.png";
import clockIcon from "common/assets/img/clockicon.png";
import userIcon from "common/assets/img/userIcon.png";
import CustomForm from "common/utils/customForm";
import EditTask from "services/Crm/components/task/editTask";
import EditMeeting from "common/modules/meeting/editMeeting";
import EditPhoneCall from "common/modules/phoneCall/editCall";
import EditUser from "common/modules/users/Edit";
import CommonDeleteModel from "common/components/commonDeleteModel";
import ConvertModal from "common/components/convertModal";
import ShareLeadModal from "common/components/shareLead";
import shareIcon from "common/assets/img/shareIconDark.png";
import EditIconDark from "common/assets/img/editIconDark.png";
import DeleteIconDark from "common/assets/img/deleteIconDark.png";
import AddIconDark from "common/assets/img/addIconDark.png";

import { PiPencil } from "react-icons/pi";
import EditRules from "services/Crm/pages/WorkflowRules/editWorkflowPage";
const Overview = (props) => {
  const {
    initialValues,
    isDataLoding,
    title,
    handleDelete,
    menuSelectedDeleteItem,
    isEdit = false,
    overviewPageTitle,
    user,
    topRoute,
    permission,
    isManual = false,
    setAction,
    isLeadConverted = false,
    setShowEmail = false,
    setShowCalendar = false,
    loadingConvertBtn = false,
    phoneCallData = {},
    phoneCallDataFunction = () => { },
  } = props;

  const [notesFieldValue, setNotesFieldValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [viewMode, setViewMode] = useState(true);
  const [deleteModel, setDeleteModal] = useState(false);
  const [noteModel, setNoteModel] = useState(false);
  const [selectedNoteId, setSelectedNoteId] = useState(null);
  const [openConvert, setOpenConvert] = useState(false);
  const [data, setData] = useState([]);
  const [notes, setNotes] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [dealRelatedFields, setDealRelatedFields] = useState({});
  const [sortOrder, setSortOrder] = useState("recentFirst"); // State to handle sorting
  const [leadName, setLeadName] = useState("");
  const [moduleName, setModuleName] = useState("");
  const [editNoteId, setEditNoteId] = useState(null);
  const [editNoteValue, setEditNoteValue] = useState("");
  const [isEditNote, setIsEditNote] = useState(false);
  const [noteUserName, setNoteUserName] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isEditNoteModalOpen, setIsEditNoteModalOpen] = useState(false);
  const [notesTitleValue, setNotesTitleValue] = useState("");
  const [editNoteTitle, setEditNoteTitle] = useState("");
  const [addNoteErrors, setAddNoteErrors] = useState({});
  const [editNoteErrors, setEditNoteErrors] = useState({});
  // const onPreview = () => {
  //   onOpen();
  // };
  const [formConfig, setFormikConfig] = useState({
    initialValues: {},
    validationSchema: null,
    onSubmit: () => { },
  });
  const {
    isOpen: isShareModalOpen,
    onOpen: openShareModal,
    onClose: closeShareModal,
  } = useDisclosure();

  const param = useParams();
  const location = useLocation();
  const path = location.pathname;

  const validPaths = ["/leads", "/contacts", "/Accounts", "/Deals"];
  const shouldShowNotes = validPaths.some((route) => path.includes(route));
  const isLeadPage = path.includes("/leads");
  const shouldShowShareModal = isLeadPage && user?.role === "superAdmin";

  const userData = useSelector((state) => state.user.user);
  const userName =
    typeof userData === "string" ? JSON.parse(userData) : userData;
  const userNameInfo = userData?.firstName + " " + userData?.lastName;

  useEffect(() => {
    if (props?.moduleData?.moduleName === constant.deals) {
      setCustomFields([
        {
          name: "account",
          schema: yup.string().required("Account is required"),
        },
      ]);
    }
  }, [props?.moduleData?.moduleName]);
  // Fetch lead data including notes
  const fetchLeadData = async () => {
    try {
      let apiEndpoint = `api/form/view/${param.id}?moduleId=${props.moduleId}`;
      if (path.includes("/leads")) apiEndpoint = `api/lead/view/${param.id}`;
      else if (path.includes("/contacts"))
        apiEndpoint = `api/contact/view/${param.id}`;

      const response = await getApi(apiEndpoint);
      if (response.status === 200) {
        if (response.data?.lead && path.includes("/leads")) {
          setLeadName(response.data?.lead?.leadName);
          setModuleName(`Lead - ${response.data?.lead?.leadName}`);
        } else if (response.data.notes && path.includes("/contacts")) {
          setModuleName(`Contact - ${response.data?.contact?.contactName}`);
        } else if (response.data.notes && path.includes("/Accounts")) {
          setModuleName(`Account - ${response.data?.data?.accountName}`);
        } else if (response.data.notes && path.includes("/Deals")) {
          setModuleName(`Deal - ${response.data?.data?.dealName}`);
        }
        if (response.data?.notes) setNotes(response.data.notes);
      }
    } catch (error) {
      console.error("Error fetching updated notes:", error);
      toast.error("Failed to refresh notes");
    }
  };

  useEffect(() => {
    if (shouldShowNotes && props?.moduleId) {
      fetchLeadData();
    }
  }, [shouldShowNotes, props.moduleId]);
  const lowerTitle = (title || "").toLowerCase();
  const useChildConfigDirectly = ["meeting", "task", "call", "user"].includes(lowerTitle);

  useEffect(() => {
    document.body.classList.add("bgWhiteImp");
    return () => {
      document.body.classList.remove("bgWhiteImp");
    };
  }, []);
  const isValidFormConfig = (config) =>
    config &&
    typeof config === "object" &&
    Object.keys(config.initialValues || {}).length > 0 &&
    typeof config.onSubmit === "function" &&
    config.validationSchema !== null;

  const defaultFormikConfig = {
    initialValues: initialValues,
    validationSchema: yup.object().shape(
      generateValidationSchema(props?.moduleData?.fields || [], customFields)
    ),
    onSubmit: () => EditData(),
  };

  const finalFormikConfig = useChildConfigDirectly
    ? formConfig
    : isValidFormConfig(formConfig)
      ? formConfig
      : defaultFormikConfig;

  const formik = useFormik({
    ...finalFormikConfig,
    enableReinitialize: true,
  });



  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;
  const singularMap = {
    Products: "Product",
    Leads: "Lead",
    Contacts: "Contact",
    Accounts: "Account",
    Deals: "Deal",
  };
  const EditData = async () => {
    try {
      setIsLoading(true);
      const response = await putApi(
        `api/form/edit/${props?.selectedId || param.id}`,
        {
          ...values,
          moduleId: props.moduleId,
          ...(props?.moduleData?.moduleName === constant.deals
            ? dealRelatedFields
            : {}),
        }
      );
      if (response.status === 200) {
        props.onClose?.();
        props.setAction((prev) => !prev);
        props.getData?.();
        toast.success(`${singularMap[title] || title} updated successfully`);
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };
  const handleOpenNoteModal = () => {
    onOpen();
  };
  const handleSaveRemarks = async (e) => {
    e.preventDefault();
    let errors = {};
    if (!notesTitleValue.trim()) errors.title = "Note title is required";
    if (!notesFieldValue.trim()) errors.message = "Note message is required";
    setAddNoteErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    setIsLoading(true);
    await saveRemarksToServer(notesTitleValue, notesFieldValue);
    setNotesFieldValue("");
    setNotesTitleValue("");
    setAddNoteErrors({});
    onClose();
  };

  const saveRemarksToServer = async (title, remarks) => {
    try {
      const addDataPayload = {
        title,
        comment: remarks,
        moduleId: props.moduleId,
      };
      const response = await postApi(
        `api/form/addNote/${initialValues._id}`,
        addDataPayload
      );
      if (response.status === 200) {
        toast.success(constant.remarksSuccess);
        await fetchLeadData(); // fetch the latest notes
      }
    } catch {
      toast.error("Failed to save remarks");
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   setViewMode(!isEdit);
  // }, [isEdit]);

  const closeDeleteModal = () => setDeleteModal(false);
  const closeConvertModal = () => setOpenConvert(false);
  const handleDeleteModal = () => handleDelete();

  const deleteNoteFromServer = async (noteId) => {
    try {
      setIsLoading(true);
      const payload = {
        noteId: noteId,
        moduleId: props.moduleId,
      };

      const response = await postApi(
        `api/form/deleteNote/${initialValues._id}`,
        payload
      );
      if (response.statusText === "OK") {
        toast.success("Note deleted successfully");
        await fetchLeadData();
      } else {
        toast.error("Failed to delete the note");
      }
    } catch (error) {
      if (userNameInfo !== noteUserName) {
        toast.error(crmConstant.unauthorizedError);
      } else {
        toast.error("An error occurred while deleting the note");
      }
    } finally {
      setIsLoading(false);
    }
  };
  const handleEditNote = (note) => {
    setEditNoteId(note._id);
    setEditNoteValue(note.comment);
    setIsEditNote(true);
    setEditNoteTitle(note.title)
    setIsEditNoteModalOpen(true);
  };
  const handleUpdateNote = async () => {
    let errors = {};
    if (!editNoteTitle.trim()) errors.title = "Note title is required";
    if (!editNoteValue.trim()) errors.message = "Note message is required";
    setEditNoteErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    try {
      setIsLoading(true);
      const payload = {
        noteId: editNoteId,
        moduleId: props.moduleId,
        comment: editNoteValue,
        title: editNoteTitle,
      };
      const response = await putApi(
        `api/form/editNote/${initialValues._id}`,
        payload
      );
      if (response.status === 200) {
        toast.success("Note updated successfully");
        setEditNoteId(null);
        setEditNoteValue("");
        setEditNoteTitle("");
        setEditNoteErrors({});
        await fetchLeadData();
      } else {
        toast.error("Failed to update note");
      }
    } catch (error) {
      toast.error("An error occurred while updating the note");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSortChange = (event) => {
    setSortOrder(event.target.value);
  };

  const closeNoteModal = () => {
    setNoteModel(false);
  };

  // Sort notes based on the selected sort order
  const sortedNotes = [...notes].sort((a, b) => {
    const dateA = new Date(a.timestamp);
    const dateB = new Date(b.timestamp);
    return sortOrder === "recentFirst" ? dateB - dateA : dateA - dateB;
  });

  const handleNoteDelete = (index) => {
    const noteToDelete = sortedNotes[index];
    setNoteUserName(noteToDelete.userName);
    if (noteToDelete && noteToDelete._id) {
      setSelectedNoteId(noteToDelete._id);
      setNoteModel(true);
    }
  };

  const handleDeleteModalNote = () => {
    if (selectedNoteId) {
      deleteNoteFromServer(selectedNoteId);
      setSelectedNoteId(null);
      setNoteModel(false);
    }
  };
  const [showConvertButton, setShowConvertButton] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConvertButton(true);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  return isDataLoding ? (
    <Flex justifyContent="center" alignItems="center" width="100%">
      <Spinner />
    </Flex>
  ) : (
    <>
      <Box className="mainOverviewContainer">
        <Grid templateColumns="repeat(5, 1fr)" gap={"20px"}>
          <GridItem colSpan={`${shouldShowNotes ? 2 : 5}`}>
            <Box className="overviewpageInfoCard">
              <Box className="overviewHeadContainer">
                <Box className="overviewTitle">{overviewPageTitle}</Box>
                <Flex gap={4} alignItems={"center"}>
                  {shouldShowShareModal && (
                    <Tooltip label="Share" hasArrow placement="top">
                      <Image
                        onClick={openShareModal}
                        src={shareIcon}
                        alt="Share"
                        h="16px"
                        w="16px"
                        cursor={"pointer"}
                      />
                    </Tooltip>
                  )}
                  {(user.role === "superAdmin" || permission?.update) && (
                    <>
                      {viewMode ? (
                        <Tooltip label="Edit" hasArrow placement="top">
                          <Image
                            onClick={() => setViewMode(false)}
                            src={EditIconDark}
                            alt="Edit"
                            h="16px"
                            w="16px"
                            cursor={"pointer"}
                          />
                        </Tooltip>
                      ) : (
                        <Box display={"flex"} alignItems={"center"} gap={"8px"}>
                          <Box className="iconBoxContainer">
                            <Tooltip label="Update" hasArrow placement="top">
                              <Button
                                className="editdetailCheckBtn"
                                disabled={
                                  isLoading || !formik.isValid || !formik.dirty
                                }
                                onClick={() => {
                                  handleSubmit();
                                  setViewMode(true);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="lucide lucide-check-icon lucide-check"
                                >
                                  <path d="M20 6 9 17l-5-5" />
                                </svg>
                              </Button>
                            </Tooltip>
                          </Box>
                          <Box
                            className="iconBoxContainer"
                            cursor={"pointer"}
                            onClick={() => {
                              setViewMode(true);
                              formik.setValues(initialValues);
                            }}
                          >
                            <Tooltip label="Close" hasArrow placement="top">
                              <CloseIcon
                                fontSize={"15px"}
                                boxSize={3}
                                color="red.500"
                              />
                            </Tooltip>
                          </Box>
                        </Box>
                      )}
                    </>
                  )}
                  {user.role !== "superAdmin" &&
                    permission?.delete &&
                    (!topRoute || (topRoute && permission?.delete)) && (
                      <Tooltip showArrow content="Delete">
                        <Image
                          onClick={() => setDeleteModal(true)}
                          src={DeleteIconDark}
                          alt="Delete"
                          h="16px"
                          w="16px"
                        />
                      </Tooltip>
                    )}

                  {/* {title === crmConstant.lead &&
              !loadingConvertBtn &&
              !isLeadConverted && (
                <Button
                  onClick={() => setOpenConvert(true)}
                  className="viewEditTabBackBtn"
                >
                  {crmConstant.convert}
                </Button>
              )} */}
                  {title === crmConstant.lead && showConvertButton &&
                    (!isLeadConverted ? (
                      <Button
                        onClick={() => setOpenConvert(true)}
                        className="viewEditTabBackBtn"
                      >
                        {crmConstant.convert}
                      </Button>
                    ) : (
                      <Button isDisabled className="viewEditTabBackBtn">
                        {crmConstant.converted}
                      </Button>
                    ))}
                </Flex>
              </Box>
              <Box className="overviewBodyContainer">
                {isManual && menuSelectedDeleteItem ? (
                  title === "Task" ? (
                    <EditTask
                      permission={permission}
                      setViewMode={setViewMode}
                      viewMode={viewMode}
                      getData={props.getData}
                      id={menuSelectedDeleteItem}
                      setAction={setAction}
                      provideFormikConfig={(config) => setFormikConfig(config)}
                      formik={formik}

                    />
                  ) : title === "Meeting" ? (
                    <EditMeeting
                      permission={permission}
                      setViewMode={setViewMode}
                      viewMode={viewMode}
                      getData={props.getData}
                      meetingData={props.leadData}
                      setAction={setAction}
                      moduleId={menuSelectedDeleteItem}
                      provideFormikConfig={(config) => setFormikConfig(config)}
                      formik={formik}
                    />
                  ) : title === "Call" ? (
                    <EditPhoneCall
                      permission={permission}
                      id={menuSelectedDeleteItem}
                      setViewMode={setViewMode}
                      viewMode={viewMode}
                      getData={phoneCallDataFunction}
                      // phoneCallData={props.leadData}
                      phoneCallData={phoneCallData}
                      setAction={setAction}
                      callId={menuSelectedDeleteItem}
                      provideFormikConfig={(config) => setFormikConfig(config)}
                      formik={formik}
                    />
                  ) : title === "User" ? (
                    <EditUser
                      permission={!permission}
                      userData={userName}
                      viewMode={viewMode}
                      setViewMode={setViewMode}
                      setAction={setAction}
                      selectedId={param?.id}
                      fetchData={props.getData}
                      data={props.leadData}
                      setShowCalendar={setShowCalendar}
                      setShowEmail={setShowEmail}
                      provideFormikConfig={(config) => setFormikConfig(config)}
                      formik={formik}
                    />
                  ) : null
                ) : (
                  <>
                    <Box className="overviewBody">
                      <CustomForm
                        viewMode={viewMode}
                        moduleData={props.leadData}
                        values={values}
                        setFieldValue={setFieldValue}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        errors={errors}
                        touched={touched}
                        setDealRelatedFields={setDealRelatedFields}
                      />
                    </Box>
                    {/* <Box className="overviewBtnContiner">
                    {viewMode ? (
                      (user.role === "superAdmin" || permission?.update) && (
                        <>
                          <Button
                            disabled={isLoading}
                            onClick={() => setViewMode(false)}
                            className="viewEditBtn"
                          >
                            <Image
                              src={WhiteEditIcon}
                              alt="edit"
                              h="16px"
                              w="16px"
                            />
                            {constant.edit}
                          </Button>
                        </>
                      )
                    ) : (
                      <Flex gap="16px">
                        <Button
                          onClick={() => {
                            setViewMode(true);
                            formik.setValues(initialValues);
                          }}
                          variant="outline"
                          className="cancelBtn theme-btn2"
                          size="sm"
                        >
                          {constant.cancel}
                        </Button>
                        <Button
                          type="submit"
                          disabled={
                            isLoading || !formik.isValid || !formik.dirty
                          }
                          onClick={handleSubmit}
                          className="viewEditBtn"
                        >
                          {constant.upload}
                        </Button>
                      </Flex>
                    )}
                  </Box> */}
                  </>
                )}
              </Box>
            </Box>
          </GridItem>
          <GridItem colSpan={3}>
            {shouldShowNotes && (
              <Box
                px={6}
                pb={6}
                display="flex"
                flexDirection="column"
                gap={2}
                bg="white"
                pt={6}
                borderRadius={"12px"}
                className="notesMainBox"
              >
                <Flex justifyContent="space-between" alignItems="center">
                  <Text className="noteBoxTitle">Notes</Text>
                  <Box display={"flex"} gap={"12px"}>
                    <Box display={"flex"} gap={"8px"} alignItems={"center"}>
                      <Text
                        fontSize={"13px"}
                        fontWeight={"500"}
                        className="sortBy"
                      >
                        Sort by:
                      </Text>
                      <Select
                        value={sortOrder}
                        onChange={handleSortChange}
                        size="sm"
                        maxWidth="200px"
                        borderRadius="8px"
                        className="noteFilter"
                      >
                        <option value="recentFirst">Recent First</option>
                        <option value="recentLast">Recent Last</option>
                      </Select>
                    </Box>

                    {/* <Button
                      disabled={isLoading}
                      leftIcon={<AddIcon color={"black"} />}
                      onClick={handleOpenNoteModal}
                      className="viewEdit"
                    >
                      {constant.add}
                    </Button> */}
                    <Text onClick={handleOpenNoteModal} className="addNoteText">
                      <Image
                        src={AddIconDark}
                        height={"16px"}
                        width={"16px"}
                        alt=""
                      />{" "}
                      Add Note
                    </Text>
                  </Box>
                </Flex>
                {/* <InputGroup className="notesFieldContainer">
                  <Textarea
                    className="notesField"
                    resize="none"
                    id="listing-note"
                    placeholder="Add a note"
                    value={notesFieldValue}
                    onChange={(e) => setNotesFieldValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.shiftKey) return;
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSaveRemarks(e);
                      }
                    }}
                  />
                </InputGroup> */}
                <div className="sendBtnContainer">
                  {/* <Button
                    disabled={isLoading}
                    leftIcon={<AddIcon />}
                    onClick={handleSaveRemarks}
                    className="viewEditBtn"
                  >
                    {constant.add}
                  </Button> */}
                </div>
                {sortedNotes && sortedNotes.length !== 0 && (
                  <Box className="noteBox">
                    {Array.isArray(sortedNotes) &&
                      sortedNotes.map((note, index) =>
                        note &&
                          typeof note === "object" &&
                          "comment" in note ? (
                          <Box
                            key={index}
                            display="flex"
                            flexDirection="column"
                            gap={2}
                            p={3}
                            className="noteWrapper"
                          >
                            <Flex justifyContent={"space-between"} gap={"16px"}>
                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                gap={"16px"}
                              >
                                <div className="user-img">
                                  <Image
                                    src={userIcon || "/placeholder.svg"}
                                    height={"48px"}
                                    width={"48px"}
                                    minWidth={"48px"}
                                    minHeight={"48px"}
                                  />
                                </div>
                                <Box>
                                  <Text className="noteUserName">
                                    {note.userName || "Unknown User"}
                                  </Text>
                                  <Text className="noteDate">
                                    {note.timestamp
                                      ? new Date(
                                        note.timestamp
                                      ).toLocaleDateString("en-US", {
                                        month: "short",
                                        day: "numeric",
                                      })
                                      : "Unknown Date"}
                                  </Text>
                                </Box>
                              </Box>
                              <Box>
                                {/* {isEditNote && editNoteId === note._id ? (
                                  <>
                                    <Box
                                      display={"flex"}
                                      alignItems={"center"}
                                      gap={"16px"}
                                      width={"60px"}
                                      minW={"60px"}
                                    >
                                      <Box className="iconBoxContainer">
                                        <CheckIcon
                                          cursor={"pointer"}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleUpdateNote();
                                            setIsEditNote(false);
                                          }}
                                        />
                                      </Box>
                                      <Box className="iconBoxContainer">
                                        <CloseIcon
                                          cursor={"pointer"}
                                          onClick={() => {
                                            setIsEditNote(false);
                                            setEditNoteId(null);
                                            setEditNoteValue("");
                                          }}
                                          fontSize={"16px"}
                                          boxSize={3}
                                          color="red.500"
                                        />
                                      </Box>
                                    </Box>
                                  </>
                                ) : (
                                  <> */}
                                <Box
                                  display={"flex"}
                                  alignItems={"start"}
                                  gap={"12px"}
                                  mt={1}
                                >
                                  {/* <EditIcon
                                        className="editIcon"
                                        cursor={"pointer"}
                                        onClick={() => handleEditNote(note)}
                                      />
                                      <DeleteIcon
                                        className="editIcon"
                                        color="red"
                                        cursor="pointer"
                                        onClick={() => handleNoteDelete(index)}
                                      /> */}
                                  <Tooltip
                                    label="Edit"
                                    hasArrow
                                    placement="top"
                                  >
                                    <Image
                                      onClick={() => handleEditNote(note)}
                                      cursor={"pointer"}
                                      src={EditIconDark}
                                      height={"16px"}
                                      width={"16px"}
                                      alt=""
                                    />
                                  </Tooltip>
                                  <Tooltip
                                    label="Delete"
                                    hasArrow
                                    placement="top"
                                  >
                                    <Image
                                      onClick={() => handleNoteDelete(index)}
                                      cursor={"pointer"}
                                      src={DeleteIconDark}
                                      height={"16px"}
                                      width={"16px"}
                                      alt=""
                                    />
                                  </Tooltip>
                                </Box>
                                {/* </>
                                )} */}
                              </Box>
                            </Flex>
                            <Box
                              display={"flex"}
                              alignItems={"start"}
                              flexDirection={"column"}
                              gap={"0px"}
                              width={"100%"}
                              mt={"14px"}
                            >
                              {note.title && (
                                <Text className="noteTitleField">
                                  {note.title}
                                </Text>
                              )}
                              {/* {!isEditNote || editNoteId !== note._id ? ( */}
                              <Text overflow={"auto"} className="noteDescText">
                                {note.comment || "No comment provided."}
                              </Text>
                              {/* ) : ( */}
                              {/* <Textarea
                                    width={"100%"}
                                    fontSize={"16px"}
                                    value={editNoteValue}
                                    onChange={(e) =>
                                      setEditNoteValue(e.target.value)
                                    }
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter" && !e.shiftKey) {
                                        e.preventDefault();
                                        handleUpdateNote();
                                      }
                                    }}
                                  />
                                )} */}
                            </Box>
                            {/* <Flex
                              alignItems="center"
                              gap={2}
                              fontSize="sm"
                              color="gray.500"
                            >
                              <p>
                                <span className="leadNameOverview">
                                  {moduleName}
                                </span>
                              </p>
                              <Text color="gray.300">&bull;</Text>
                              <Image
                                src={clockIcon || "/placeholder.svg"}
                                alt="clock"
                                h="16px"
                                w="16px"
                                mt={"3px"}
                              />
                              
                            </Flex> */}
                          </Box>
                        ) : null
                      )}
                  </Box>
                )}
              </Box>
            )}
          </GridItem>
        </Grid>
      </Box>

      <Modal onClose={onClose} isOpen={isOpen}>
        <ModalOverlay />
        <ModalContent maxW={"600px"} width={"100%"}>
          <ModalHeader
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            className="modalHeader"
          >
            <Text className="modalHeaderTitle">Add New Note</Text>
            <ModalCloseButton fontSize={"14px"} />
          </ModalHeader>
          <ModalBody>
            <Box className="formContainerField" mb={6}>
              <FormLabel className="formlabelText">
                Title <span style={{ color: "red" }}>*</span>
              </FormLabel>
              <InputGroup className="notesFieldContainer">
                <Input
                  placeholder="Enter Title"
                  className="notesTitleField"
                  value={notesTitleValue}
                  onChange={(e) => setNotesTitleValue(e.target.value)}
                />

              </InputGroup>
              <Box width={"100%"}>
                {addNoteErrors.title && (
                  <Text mt="4px" fontSize="sm" color={"red"}>
                    {addNoteErrors.title}
                  </Text>
                )}
              </Box>
            </Box>
            <Box className="formContainerField">
              <FormLabel className="formlabelText">Message <span style={{ color: "red" }}>*</span></FormLabel>
              <InputGroup className="notesFieldContainer">
                <Textarea
                  className="notesField"
                  resize="none"
                  id="listing-note"
                  h={"200px"}
                  placeholder="Enter Message Here"
                  value={notesFieldValue}
                  onChange={(e) => setNotesFieldValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.shiftKey) return;
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSaveRemarks(e);
                    }
                  }}
                />
              </InputGroup>
              <Box width={"100%"}>
                {addNoteErrors.message && (
                  <Text mt="4px" fontSize="sm" color={"red"}>
                    {addNoteErrors.message}
                  </Text>
                )}
              </Box>
            </Box>
          </ModalBody>
          <ModalFooter className="modalFooter">
            <Box display={"flex"} justifyContent={"end"} gap={"8px"}>
              <Button
                className="outlinedBtn"
                onClick={onClose}
                variant={"outlined"}
              >
                Cancel
              </Button>
              <Button
                disabled={isLoading}
                onClick={handleSaveRemarks}
                className="filledBtn"
              >
                {constant.save}
              </Button>
            </Box>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        onClose={() => {
          setIsEditNoteModalOpen(false);
          setIsEditNote(false);
          setEditNoteId(null);
          setEditNoteValue("");
          setEditNoteTitle("");
        }}
        isOpen={isEditNoteModalOpen}
      >
        <ModalOverlay />
        <ModalContent maxW={"600px"} width={"100%"}>
          <ModalHeader
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            className="modalHeader"
          >
            <Text className="modalHeaderTitle">Edit Note</Text>
            <ModalCloseButton fontSize={"14px"} />
          </ModalHeader>
          <ModalBody>
            <Box className="formContainerField" mb={6}>
              <FormLabel className="formlabelText">Title</FormLabel>
              <InputGroup className="notesFieldContainer">
                <Input
                  placeholder="Enter Title"
                  className="notesTitleField"
                  value={editNoteTitle}
                  onChange={(e) => setEditNoteTitle(e.target.value)}
                />
              </InputGroup>
              {/* <Box width={"100%"}>
                {editNoteErrors.title && (
                <Text mb="10px" fontSize="sm" color={"red"}>
                  {editNoteErrors.title}
                </Text>
              )}
              </Box> */}
            </Box>
            <Box className="formContainerField">
              <FormLabel className="formlabelText">Message</FormLabel>
              <InputGroup className="notesFieldContainer">
                <Textarea
                  className="notesField"
                  resize="none"
                  id="edit-note"
                  placeholder="Edit your note"
                  value={editNoteValue}
                  onChange={(e) => setEditNoteValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleUpdateNote();
                      setIsEditNoteModalOpen(false);
                      setIsEditNote(false);
                    }
                  }}
                />
              </InputGroup>
              {/* <Box width={"100%"}>
                {editNoteErrors.message && (
                <Text mb="10px" fontSize="sm" color={"red"}>
                  {editNoteErrors.message}
                </Text>
              )}</Box> */}
            </Box>
          </ModalBody>
          <ModalFooter className="modalFooter">
            <Box display={"flex"} justifyContent={"end"} gap={"8px"}>
              <Button
                className="outlinedBtn"
                variant={"outlined"}
                onClick={() => {
                  setIsEditNoteModalOpen(false);
                  setIsEditNote(false);
                  setEditNoteId(null);
                  setEditNoteValue("");
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={isLoading}
                onClick={() => {
                  handleUpdateNote();
                  setIsEditNoteModalOpen(false);
                  setIsEditNote(false);
                }}
                className="filledBtn"
              >
                {constant.save}
              </Button>
            </Box>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <CommonDeleteModel
        notCheckbox={true}
        isOpen={deleteModel}
        onClose={closeDeleteModal}
        type={`${title}`}
        handleDeleteData={handleDeleteModal}
        ids={menuSelectedDeleteItem}
      />

      <CommonDeleteModel
        isOpen={noteModel}
        onClose={() => {
          setNoteModel(false);
          setSelectedNoteId(null);
        }}
        type={"Note"}
        ids={""}
        handleDeleteData={handleDeleteModalNote}
      />
      {openConvert && (
        <ConvertModal
          data={props.selectedData}
          leadId={param.id}
          title={title}
          isOpen={openConvert}
          onClose={closeConvertModal}
          fetchData={props.getData}
        />
      )}
      {shouldShowShareModal && (
        <ShareLeadModal
          isOpen={isShareModalOpen}
          onClose={closeShareModal}
          leadId={param.id}
          moduleId={props.moduleId}
          leadName={initialValues?.leadName || leadName}
          companyName={initialValues?.companyName}
          leadOwner={initialValues?.leadOwner}
        />
      )}
    </>
  );
};

export default Overview;
